import React, { useState } from 'react';
import './App.css';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Auth from './components/Auth';
import Hero from './components/Hero';
import Wrappers from './components/Wrappers';
import RequestQuote from './components/RequestQuote';
import Shoes from './components/Shoes';
import Bags from './components/Bags';
import Art from './components/Art';
import Livestream from './components/Livestream';
import Blog from './components/Blog';
import Cart from './components/Cart';
import Checkout from './components/Checkout';
import Footer from './components/Footer';

function App() {
  const [currentSection, setCurrentSection] = useState('home');
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [quoteProduct, setQuoteProduct] = useState(null);

  return (
    <CartProvider>
      <AuthProvider>
        <div className="App">
          <Navbar setCurrentSection={setCurrentSection} currentSection={currentSection} />
          {showAuthModal && <Auth onClose={() => setShowAuthModal(false)} />}
          
          {currentSection === 'home' && <Hero setCurrentSection={setCurrentSection} />}
          {currentSection === 'wrappers' && <Wrappers setCurrentSection={setCurrentSection} setQuoteProduct={setQuoteProduct} />}
          {currentSection === 'quote' && <RequestQuote setCurrentSection={setCurrentSection} quoteProduct={quoteProduct} />}
          {currentSection === 'shoes' && <Shoes />}
          {currentSection === 'bags' && <Bags />}
          {currentSection === 'art' && <Art />}
          {currentSection === 'livestream' && <Livestream />}
          {currentSection === 'blog' && <Blog />}
          {currentSection === 'cart' && <Cart setCurrentSection={setCurrentSection} />}
          {currentSection === 'checkout' && <Checkout setCurrentSection={setCurrentSection} setShowAuthModal={setShowAuthModal} />}
          
          <Footer />
        </div>
      </AuthProvider>
    </CartProvider>
  );
}

export default App;
